import React from 'react';
import { GraduationCap, MapPin, Mail, Phone, School, Award, Globe } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-5">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-primary">À propos</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Découvrez mon parcours académique, mes passions et mes aspirations professionnelles
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Texte de présentation */}
          <div className="animate-slide-left">
            <h3 className="text-2xl font-bold mb-6">Qui suis-je ?</h3>
            <p className="text-gray-300 mb-6">
              Je suis actuellement étudiant en 3ème année de Baccalauréat en Génie Informatique à l'Université du Québec à Chicoutimi (UQAC). 
              Mon parcours m'a permis d'acquérir des compétences en développement logiciel, réseaux informatiques, architecture des systèmes 
              et ingénierie des logiciels, à travers un programme rigoureux.
            </p>
            <p className="text-gray-300 mb-6">
              Passionné par les innovations technologiques, je m'intéresse particulièrement à l'Intelligence artificielle et le 
              développement logiciel. Je poursuis activement mon apprentissage et mon perfectionnement dans ce sens pour pouvoir relever
              de grands défis technologiques.
            </p>
            
            <div className="mt-8 p-6 bg-gray-800/30 rounded-xl border border-gray-700">
              <h4 className="text-xl font-semibold mb-4 flex items-center gap-2">
                <Award className="text-primary" size={20} />
                Objectifs professionnels
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                  <span className="text-gray-300">Obtenir un stage dans le domaine informatique</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                  <span className="text-gray-300">Développer mes compétences en IA et Machine Learning</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                  <span className="text-gray-300">Contribuer à des projets innovants</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Informations personnelles */}
          <div className="animate-slide-right">
            <div className="bg-gray-800/30 p-8 rounded-2xl border border-gray-700">
              <h3 className="text-2xl font-bold mb-8">Informations personnelles</h3>
              
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                    <GraduationCap className="text-primary" size={24} />
                  </div>
                  <div>
                    <div className="text-gray-400">Formation</div>
                    <div className="text-lg">Baccalauréat en Génie Informatique</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                    <School className="text-primary" size={24} />
                  </div>
                  <div>
                    <div className="text-gray-400">Université</div>
                    <div className="text-lg">Université du Québec à Chicoutimi</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                    <Globe className="text-primary" size={24} />
                  </div>
                  <div>
                    <div className="text-gray-400">Langues</div>
                    <div className="text-lg">Français, Anglais</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                    <MapPin className="text-primary" size={24} />
                  </div>
                  <div>
                    <div className="text-gray-400">Localisation</div>
                    <div className="text-lg">Saguenay, Québec</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                    <Mail className="text-primary" size={24} />
                  </div>
                  <div>
                    <div className="text-gray-400">Email</div>
                    <div className="text-lg">nyhien@etu.uqac.ca</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                    <Phone className="text-primary" size={24} />
                  </div>
                  <div>
                    <div className="text-gray-400">Téléphone</div>
                    <div className="text-lg">+1 (418) 812-4143</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;